// extracted by mini-css-extract-plugin
module.exports = {"root":"NRICSettingForm_root__b6Wc3","inputField":"NRICSettingForm_inputField__10Sks","readMore":"NRICSettingForm_readMore__2XPX-","learnMore":"NRICSettingForm_learnMore__H8x4u"};